/* unplugin-vue-components disabled */import script from "./XTableExample.vue?vue&type=script&setup=true&lang=ts"
export * from "./XTableExample.vue?vue&type=script&setup=true&lang=ts"

import "./XTableExample.vue?vue&type=style&index=0&id=6a60cc36&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6a60cc36"]])

export default __exports__